<roma-modal-template
  [title]="'table.colum.asset' | translate"
  [showSuccessBtn]="false"
  [showCancelBtn]="false"
  (cancel)="ok()"
>
  <div class="container-item">
    <div class="grid">
      <div class="row">
        <mat-chip
          class="example-box michip"
          cdkDrag
          *ngFor="let asset of assets"
        >
          {{ asset.name }}
        </mat-chip>
      </div>
    </div>
  </div>
</roma-modal-template>
